import { initContract } from '@ts-rest/core';
import { publicAuthContract } from './auth.public.contract';
import { authAuthContract } from './auth.auth.contract';

const c = initContract();

export const authContract = c.router(
  {
    auth: authAuthContract,
    public: publicAuthContract,
  },
  {
    pathPrefix: '/auth',
    strictStatusCodes: true,
  }
);

export * from './auth.auth.contract';
export * from './auth.public.contract';
export * from './models';
